import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { SnackbarProvider } from "notistack";

const App = () => {
  return (
    <SnackbarProvider
      autoHideDuration={3000}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <AppRoutes />
    </SnackbarProvider>
  );
};

export default App;
